import Swiper, {Navigation, Pagination} from 'swiper';

const reviewsSlider = document.querySelector('.j-reviews-slider');

if (reviewsSlider) {
    let slider = {};
    const options = {
        modules      : [Navigation, Pagination],
        loop         : false,
        speed        : 800,
        // spaceBetween : 10,
        slidesPerView: 'auto',
        pagination   : {
            el  : '.j-reviews-pagination',
            type: 'custom',
            renderCustom(_, current, total) {
                const newCurrent = current < 10 ? `0${current}` : current;
                const newTotal = total < 10 ? `0${total}` : total;

                return `<span class="slider-control__current">${newCurrent}</span>
                           <span class="slider-control__total">/ ${newTotal}</span>`;
            }
        },
        navigation: {
            nextEl: '.j-reviews-next',
            prevEl: '.j-reviews-prev'
        }
    };

    slider = new Swiper(reviewsSlider, options);
    slider.init();
}
